var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("page-header", {
            attrs: {
              actions: [
                {
                  component: "ActionButton",
                  text: "No Disponible para Vincular",
                  icon: "fas fa-times-circle color-primary-1",
                  variant: "outline-success",
                  visible: this.canInactivate,
                  click: () => (_vm.showDisciplineTypeComponent = true)
                },
                {
                  component: "ActionButton",
                  text: "Inactivar",
                  icon: "fas fa-user-slash",
                  variant: "outline-success",
                  click: this.onInactivate,
                  visible: this.canInactivate
                },
                {
                  component: "ActionButton",
                  text: "Re-Activar",
                  variant: "outline-success",
                  icon: "fas fa-user-alt",
                  click: this.onActivate,
                  visible: this.canActivate
                }
              ],
              "on-return": () => _vm.$router.go(-1),
              page: _vm.page
            }
          }),
          _vm.showDisciplineTypeComponent
            ? _c("selection-component", {
                staticClass: "mb-3",
                attrs: {
                  "error-msgs": {},
                  icon: "fas fa-folder-tree",
                  label: {
                    main: "Disciplina(s) disponible(s) para Vincular",
                    selected: "Disciplinas Removidas",
                    dd: "Disciplina(s):"
                  },
                  list: _vm.listDisciplineTypes,
                  save: _vm.saveDisciplineType
                },
                on: {
                  onClose: function($event) {
                    return _vm.onClosedDisciplineType()
                  }
                }
              })
            : _vm._e(),
          _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
          _c("section-title", {
            attrs: { content: "Información General", "has-line": true }
          }),
          _c(
            "GeneralInformation",
            {
              attrs: {
                "initial-npi": _vm.initialNpi,
                "initial-npi-depr": _vm.initialNpiDepr,
                "is-medicaid-documentation-workflow-enabled":
                  _vm.isMedicaidDocumentationWorkflowEnabled,
                "show-edit": _vm.canEditGeneralInformation,
                "show-school-section": _vm.showSchoolSection
              },
              on: { "save-npi": _vm.saveNpi, "save-npi-depr": _vm.saveDeprNpi },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _c(
                "span",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c(
                    "action-button",
                    {
                      attrs: {
                        disabled: !_vm.hasGeneralInfoPendingChanges,
                        i: "fas fa-times-circle",
                        text: "Cancelar",
                        variant: "outline-danger danger"
                      },
                      on: { click: _vm.handleCancelGeneralInfo }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "action-button",
                    {
                      attrs: {
                        disabled: !_vm.hasGeneralInfoPendingChanges,
                        i: "fas fa-save",
                        variant: "success ml-4"
                      },
                      on: { click: _vm.handleSaveGeneralInfo }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            ]
          ),
          _c("section-title", {
            attrs: { content: "Información Demográfica", "has-line": true }
          }),
          _c("div", { staticClass: "row mb-4 pl-3" }, [
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("custom-input-display", {
                  attrs: { label: " Tipo de Lugar:" },
                  model: {
                    value: _vm.model.locationTypeName,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationTypeName", $$v)
                    },
                    expression: "model.locationTypeName"
                  }
                })
              ],
              1
            ),
            _vm.showProviderOfficeSection ||
            _vm.showHogarSection ||
            _vm.isAssistedTherapy
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Nombre:" },
                      model: {
                        value: _vm.model.locationName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "locationName", $$v)
                        },
                        expression: "model.locationName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCSEESection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Centro:" },
                      model: {
                        value: _vm.model.centerName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "centerName", $$v)
                        },
                        expression: "model.centerName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCSEESection ||
            _vm.showProviderOfficeSection ||
            _vm.isAssistedTherapy
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Municipio:" },
                      model: {
                        value: _vm.model.municipalityName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "municipalityName", $$v)
                        },
                        expression: "model.municipalityName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCAATSection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Caat:" },
                      model: {
                        value: _vm.model.caatName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "caatName", $$v)
                        },
                        expression: "model.caatName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCAATSection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Municipio:" },
                      model: {
                        value: _vm.model.caatMunicipalityName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "caatMunicipalityName", $$v)
                        },
                        expression: "model.caatMunicipalityName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Región:" },
                      model: {
                        value: _vm.model.regionName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "regionName", $$v)
                        },
                        expression: "model.regionName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Distrito:" },
                      model: {
                        value: _vm.model.districtName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "districtName", $$v)
                        },
                        expression: "model.districtName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.showSchoolSection
              ? _c(
                  "div",
                  { staticClass: "col-sm" },
                  [
                    _c("custom-input-display", {
                      attrs: { label: "Escuela:" },
                      model: {
                        value: _vm.model.locationSchoolName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "locationSchoolName", $$v)
                        },
                        expression: "model.locationSchoolName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c("b-row", [
                !_vm.showHogarSection
                  ? _c(
                      "div",
                      { staticClass: "mt-3 mb-1 col-12" },
                      [
                        _c("address-information-list", {
                          attrs: {
                            "add-enabled": _vm.userHasPermissions(
                              "servicelocation.address.add"
                            ),
                            "delete-enabled": _vm.userHasPermissions(
                              "servicelocation.address.delete"
                            ),
                            "edit-enabled": _vm.userHasPermissions(
                              "servicelocation.address.edit"
                            ),
                            "fiscal-year-id": _vm.fiscalYearId,
                            "on-deleting": _vm.onAddressDeleting,
                            "on-saving": _vm.onAddressSaving
                          },
                          model: {
                            value: _vm.model.addresses,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "addresses", $$v)
                            },
                            expression: "model.addresses"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("b-row", [
                _c(
                  "div",
                  { staticClass: "mt-3 mb-1 col-12" },
                  [
                    _c("contact-information-list", {
                      attrs: {
                        "add-enabled": _vm.userHasPermissions(
                          "servicelocation.contact.add"
                        ),
                        "civil-statuses": _vm.civilStatuses,
                        "delete-enabled": _vm.userHasPermissions(
                          "servicelocation.contact.delete"
                        ),
                        "edit-enabled": _vm.userHasPermissions(
                          "servicelocation.contact.edit"
                        ),
                        "on-deleting": _vm.onContactDeleting,
                        "on-saving": _vm.onContactSaving
                      },
                      model: {
                        value: _vm.model.contacts,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "contacts", $$v)
                        },
                        expression: "model.contacts"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.model.certification && _vm.isMedicaidDocumentationWorkflowEnabled
            ? _c("section-title", {
                attrs: {
                  content: "Información de Certificación de Escuela",
                  "has-line": true
                }
              })
            : _vm._e(),
          _vm.model.certification && _vm.isMedicaidDocumentationWorkflowEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "row p-4 my-3 justify-content-start bg-light align-items-center rounded"
                },
                [
                  _c("div", { staticClass: "col-3 d-flex flex-column" }, [
                    _c("label", { staticClass: "text-muted" }, [
                      _vm._v("Fecha de Certificación:")
                    ]),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.model.certification.date)) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-3 d-flex flex-column" }, [
                    _c("label", { staticClass: "text-muted" }, [
                      _vm._v("Fecha de Vigencia:")
                    ]),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("date")(
                              _vm.model.certification.expirationDate
                            )
                          ) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-3 d-flex flex-column" }, [
                    _c("label", { staticClass: "text-muted" }, [
                      _vm._v("Documento:")
                    ]),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " + _vm._s(_vm.model.certification.documentName) + " "
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-3 d-flex flex-column align-items-end" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-file-download",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onDownloadHandler(
                              _vm.model.certification.documentId
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }